import { Visitor, VisitorPhone } from 'entities/Visitor';
import { Actions } from './actions';
import {
  GET_VISITORS_REQUEST,
  GET_VISITORS_ERROR,
  GET_VISITORS_SUCCESS,
  GET_VISITOR_PHONES_ERROR,
  GET_VISITOR_PHONES_SUCCESS,
  GET_VISITOR_PHONES_REQUEST,
  GET_VISITOR_PHONE_DELETE,
  GET_VISITOR_DELETE,
  GET_VISITOR_PHONE_ADD,
  GET_VISITOR_ADD_OR_UPDATE,
} from './constants';

const initialState = {
  visitors: [] as Visitor[],
  loading: false as boolean,
  error: null as Error | null,
};

type VisitorsTabState = typeof initialState;

export const visitorsTabReducer = (state: VisitorsTabState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_VISITORS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
        fio: action.payload.fio,
        number: action.payload.number,
      };
    }
    case GET_VISITOR_ADD_OR_UPDATE: {
      return {
        ...state,
        loading: true,
        error: null,
        visitor: action.payload.visitor,
      };
    }
    case GET_VISITORS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        visitors: action.payload.visitors,
      };
    }
    case GET_VISITORS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    default: {
      return state;
    }
  }
};

const phonesInitialState = {
  phones: [] as VisitorPhone[],
  loading: false as boolean,
  error: null as Error | null,
};

type VisitorPhonesTabState = typeof phonesInitialState;

export const visitorPhonesTabReducer = (state: VisitorPhonesTabState = phonesInitialState, action: Actions) => {
  switch (action.type) {
    case GET_VISITOR_PHONES_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case GET_VISITOR_PHONES_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        phones: action.payload.phones,
      };
    }
    case GET_VISITOR_PHONES_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    case GET_VISITOR_PHONE_DELETE: {
      return {
        ...state,
        loading: true,
        error: null,
        numberId: action.payload.numberId,
        visitorId: action.payload.visitorId,
      };
    }
    case GET_VISITOR_DELETE: {
      return {
        ...state,
        loading: true,
        error: null,
        visitorId: action.payload.visitorId,
      };
    }
    case GET_VISITOR_PHONE_ADD: {
      return {
        ...state,
        loading: true,
        error: null,
        data: action.payload.data,
        visitorId: action.payload.visitorId,
      };
    }
    default: {
      return state;
    }
  }
};
